import { gql } from '@apollo/client';

export const ImageWrapperFragment = gql(`
    fragment ImageWrapperFragment on ImageWrapper {
        __typename
        sys {
            id
        }
        cloudinaryMedia
        description
        title
        altText
    }
`);
